import androidx.compose.runtime.CompositionLocalProvider
import com.varabyte.kobweb.core.AppGlobals
import com.varabyte.kobweb.navigation.BasePath
import com.varabyte.kobweb.navigation.Router
import com.varabyte.kobweb.navigation.UpdateHistoryMode
import com.varabyte.kobweb.navigation.remove
import com.varabyte.kobweb.silk.defer.DeferringHost
import kotlinx.browser.document
import kotlinx.browser.window
import org.jetbrains.compose.web.renderComposable

public fun main() {
    AppGlobals.initialize(mapOf("title" to "Book Brief"))
    BasePath.set("")
    val router = Router()
    com.varabyte.kobweb.core.init.initKobweb(router) { ctx ->
        ctx.router.register("/") { todo.pages.HomePage() }
        ctx.router.register("/removeUser") { todo.pages.RemoveUserPage() }

    }
    router.addRouteInterceptor {
        path = path.removeSuffix(".html").removeSuffix(".htm")
    }

    com.varabyte.kobweb.silk.init.additionalSilkInitialization = { ctx ->
        com.varabyte.kobweb.silk.init.initSilkWidgets(ctx)
        com.varabyte.kobweb.silk.init.initSilkWidgetsKobweb(ctx)
        ctx.theme.registerStyle("todo", todo.components.widgets.TodoStyle)
        ctx.theme.registerStyle("todo-container", todo.components.widgets.TodoContainerStyle)
        ctx.theme.registerStyle("todo-text", todo.components.widgets.TodoTextStyle)
        ctx.theme.registerStyle("todo-input", todo.components.widgets.TodoInputStyle)
        ctx.theme.registerStyle("todo-clickable", todo.components.widgets.TodoClickableStyle)
        ctx.theme.registerStyle("main-container", todo.pages.MainContainer)
        ctx.theme.registerStyle("card", todo.pages.CardStyle)
        ctx.theme.registerStyle("input", todo.pages.InputStyle)
        ctx.theme.registerStyle("hidden", todo.pages.HiddenStyle)
        ctx.theme.registerStyle("title", todo.pages.TitleStyle)
        ctx.theme.registerStyle("button", todo.pages.ButtonStyle)
        ctx.theme.registerStyle("button-modifier", todo.pages.ButtonModifier)
        ctx.theme.registerStyle("form-container", todo.pages.FormContainer)
        ctx.theme.registerStyle("text-span-modifier", todo.pages.TextSpanModifier)
        ctx.theme.registerStyle("form-group", todo.pages.FormGroup)
        ctx.theme.registerStyle("form-label", todo.pages.FormLabel)
        ctx.theme.registerStyle("footer", todo.pages.FooterStyle)
        ctx.theme.registerStyle("social-link", todo.pages.SocialLinkStyle)
        todo.initSiteStyles(ctx)
    }

    router.tryRoutingTo(BasePath.remove(window.location.href.removePrefix(window.origin)),
            UpdateHistoryMode.REPLACE)

    // For SEO, we may bake the contents of a page in at build time. However, we will
    // overwrite them the first time we render this page with their composable, dynamic
    // versions. Think of this as poor man's hydration :)
    // See also: https://en.wikipedia.org/wiki/Hydration_(web_development)
    val root = document.getElementById("_kobweb-root")!!
    while (root.firstChild != null) { root.removeChild(root.firstChild!!) }

    renderComposable(rootElementId = "_kobweb-root") {
        todo.AppEntry {
            router.renderActivePage { DeferringHost { it() } }
        }
    }
}
